import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { withTranslation } from "react-i18next";

import { Spinner } from "reactstrap";

import { useHistory } from "react-router-dom";
import { loginUser } from "../../store/auth/login/actions";
import { showToast } from "../../Libs/CustomMethods/showToast";

const LoginSSO = ({ t }) => {
  const { data: token } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { error, loading } = useSelector((state) => state.Login);

  useEffect(() => {
    if (token) {
      localStorage.removeItem("authUser");
      localStorage.removeItem("lastUser");
      dispatch(loginUser(null, history, token));
    }
  }, [dispatch, history, token]);

  useEffect(() => {
    if (error) {
      showToast(
        t("Sorry! something went wrong, please contact our support team"),
        "error",
        () => history.push("/login")
      );
    }
  }, [error, history, t]);

  return (
    <React.Fragment>
      {loading && (
        <div className="w-100 h-100 justify-content-center p-4">
          <div className="text-center pb-4">
            <Spinner animation="border" size="sm" className="spinner" />
          </div>

          <div className="text-center mt-2">
            {t("Wait.. you will be redirected to dashboard soon...")}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(LoginSSO);
